

function LeadershipTier15DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                A +1 bonus to Armor Class & Dexterity Saving Throws when in at least half cover is a very strong positional advantage for your entire team.
                <p>
                    Half-Cover grants a +2 bonus to AC and Dexterity Saves when behind cover that blocks at least half of your body.
                    <br />
                    A +1 bonus is a <b>50% increase</b> to this benefit.
                </p>
                <p>
                    Three-Quarters-Cover grants a +5 bonus to AC and Dexterity Saves when behind cover that blocks 3/4ths of your body.
                    <br />
                    A +1 bonus is a <b>20% increase</b> to this benefit.
                </p>
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY ONLY WHEN IN COVER?</b>
                <div className="animationFadeIn">
                    This greatly encourages your team to take advantage of the powerful cover system afforded to players in D&D.
                    <br />
                    As a Dungeon Master, you could use this ability to justify putting them into an epic holdout against
                    a massive horde of weaker enemies which really makes the players shine, especially the Leader.
                </div>
            </p>
            <p>
                <b className="AbilityHeaderSmall">THEMING</b>
                <div className="animationFadeIn">
                    You've really got it all Commander.
                    <br />
                    You always have your team in the perfect position, you coordinate their attacks, and now you even make them
                    extremely resilient when in a fortified position.
                    <br />
                    A Phalanx is an Ancient Greek military formation that involves
                    overlapping shields to provide a powerful defensive boost against enemy attacks.
                </div>
            </p>
            <br />
        </div>
    )
}

export { LeadershipTier15DesignTemplate };